import { useState } from "react"
import Icon from "../../components/Icon"
import SearchDropdown from "./SearchDropdown"

const kindIcon = (kind) => (kind === "water" ? "droplet-fill" : kind === "trash" ? "trash3-fill" : "tag")

// The console used to wrap every item/category into a chip row, which grows
// unusable once a company bills many things. This is a search box that opens
// the full alphabetical list, so finding one item works the same whether the
// company has two or two hundred.
function ItemCategoryDropdown({ categories = [], countFor }) {
  const [selectedId, setSelectedId] = useState("")

  const options = [...categories]
    .sort((a, b) =>
      String(a?.name || "").localeCompare(String(b?.name || ""), undefined, { sensitivity: "base" })
    )
    .map((category) => ({
      key: String(category._id),
      label: category.name || "",
      searchText: category.name || "",
      category,
    }))

  return (
    <SearchDropdown
      options={options}
      selectedKey={selectedId}
      onSelect={(option) => setSelectedId(option.key)}
      onClear={() => setSelectedId("")}
      placeholder="Search item/category…"
      emptyText="No item or category matches your search."
      renderOption={({ category }) => (
        <span className="flex min-w-0 flex-1 items-center gap-1.5">
          <Icon name={kindIcon(category.kind)} size="0.65rem" className="shrink-0 text-teal-600" />
          <span className="truncate font-bold text-slate-800">{category.name}</span>
          {Boolean(category.autoInvoiceEnabled) && (
            <Icon name="arrow-repeat" size="0.65rem" className="shrink-0 text-emerald-600" />
          )}
          <span className="ml-auto shrink-0 rounded bg-slate-100 px-1 text-[10px] font-bold text-slate-600">
            {countFor(category)}
          </span>
        </span>
      )}
    />
  )
}

export default ItemCategoryDropdown
